import { memo, FC, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import { PropertyDisclaimerTitle } from './property-disclaimer-title';
import { PropertyDisclaimers } from './property-disclaimers';
import { PropertyTeaserType } from "store/properties/types";
import { Videos } from "new-architecture/components/videos";
import { useTrackTeaserProductVideoOpenedMutation } from 'api/analitics';

import style from './style.module.scss';

interface PropertyDisclaimerProps {
  disclaimers: Array<string>;
  property: PropertyTeaserType;
}

export const PropertyDisclaimer: FC<PropertyDisclaimerProps> = memo(({
  disclaimers,
  property
}) => {
  const { sectionAssets } = property;
  const { disclaimer: disclaimerVideos } = sectionAssets || {};

  const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
  const onOpenVideo = useCallback((videoUrl: string) => {
    trackProductVideoOpened({
      opportunity: property.name,
      opportunityId: property._id,
      productVideoUrl: videoUrl
    });
  }, [trackProductVideoOpened, property]);
  return (
    <Container>
      <PropertyDisclaimerTitle />
      <Videos videos={disclaimerVideos || []} onOpenVideo={onOpenVideo} />
      <div className={style['disclaimer-container']}>
        <PropertyDisclaimers disclaimers={disclaimers} />
      </div>
    </Container>
  )
});
